"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormCategories = void 0;
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var FormCategories = function (_a) {
    var categories = _a.categories, onChange = _a.onChange;
    return react_1.default.createElement(storybook_1.Layouts.Fullscreen, { returnUrl: '/videos' },
        react_1.default.createElement(storybook_1.Layouts.Container, null,
            react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h1' }, "Video uploaden"),
            react_1.default.createElement(storybook_1.Texts.Primary, null, "Kies een categorie die het beste bij jouw video past"),
            react_1.default.createElement("ul", { className: 'storybook-videos-form-categories' }, categories.map(function (category, key) {
                return react_1.default.createElement(storybook_1.Videos.FormCategoryItem, { key: key, icon: category.name, label: category.label, onClick: function () { return onChange(category.id); } });
            }))));
};
exports.FormCategories = FormCategories;
